/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the 'My Space'
 * category menu of the sidebar 
 */

// Imports
import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouseChimney, faLaptopFile, faPaperPlane, faVideo } from "@fortawesome/free-solid-svg-icons";

// Interfaces
import { MySpaceRenderableComponent } from '../../interfaces/IUtils';
import { Dossier } from '../../interfaces/IDossiers';
import { BuroSecureSettings, PublicCabinet } from '../../interfaces/ICabinets';

export const SideBarMySpaceMenu = ({ expanded = false, ...props }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const backBuroSecure = JSON.parse(localStorage.getItem('buroSecure') || '{}') as BuroSecureSettings;
    const cabinet: PublicCabinet = (JSON.parse(localStorage.getItem('cabinet') || "{}") as PublicCabinet);
    const color = props.cabinet?.color ?? cabinet.color ?? '#E7812B';

    const renderComponent = (component: MySpaceRenderableComponent) => {
        if (location.pathname === '/accueil')
            props.changeRenderedComponent(component);
        else
            navigate('/accueil', { state: { renderedComponent: component, dossier: props.dossier || {} as Dossier } });
    }

    // JSX Template
    return (
        <div className={`flex flex-col items-left ${props.className || ''}`}>

            {/* Home page */}
            <div className="flex flex-row items-center cursor-pointer" tabIndex={6} onClick={() => { renderComponent(MySpaceRenderableComponent.Home) }}>
                <FontAwesomeIcon icon={faHouseChimney} className='w-8 h-7 my-2' style={{ color }} />
                <span className={`ml-2 ${!expanded ? 'hidden' : ''}`}>Accueil</span>
                <span className={`w-4 ml-2 ${!expanded ? 'hidden' : ''}`}></span>
            </div>

            {/* Document deposit */}
            {((backBuroSecure.enabled && cabinet.permissions?.isBurosecureEnabled)) ?
                //&& localStorage.getItem('eclusrRef') && ['1', '2', '4', '224', '230'].includes(localStorage.getItem('eclusrRef')!)) ? // TO REMOVE (WAITING FOR SV DEV)
                <div className="flex flex-row items-center cursor-pointer" onClick={() => { renderComponent(MySpaceRenderableComponent.DocumentDeposit) }}>
                    <FontAwesomeIcon icon={faPaperPlane} className='w-8 h-7 my-2' style={{ color }} />
                    <span className={`ml-2 ${!expanded ? 'hidden' : ''}`}>Envoi de documents</span>
                    <span className={`w-4 ml-2 ${!expanded ? 'hidden' : ''}`}></span>
                </div> : <></>}

            {/* Documents envoyés */}
            {((backBuroSecure.enabled && cabinet.permissions?.isBurosecureEnabled)) ?
                //&& localStorage.getItem('eclusrRef') && ['1', '2', '4', '224', '230'].includes(localStorage.getItem('eclusrRef')!)) ? // TO REMOVE (WAITING FOR SV DEV)
                <div className={`flex flex-row items-center cursor-pointer ${!props.dossier.DOS_REF ? '' : 'hidden'}`} onClick={() => { renderComponent(MySpaceRenderableComponent.SentDocuments) }}>
                    <FontAwesomeIcon icon={faLaptopFile} className='w-8 h-8 my-2' style={{ color }} />
                    <span className={`ml-2 ${!expanded ? 'hidden' : ''}`}>Documents envoyés</span>
                    <span className={`w-4 ml-2 ${!expanded ? 'hidden' : ''}`}></span>
                </div> : <></>}

            {/* BUROCLIC's tutorial (buroclic's CONTACT DB only) */}
            {((["CONTACT", "BUROCLIC", "DEVELOPPEURS_EXPDEMO"].includes(cabinet.dbName.toUpperCase())) && (cabinet.host === "bc.buroclic.com" || cabinet.host === "192.168.1.140")) /* DEBUG LOCAL */ ?
                //&& localStorage.getItem('eclusrRef') && ['1', '2', '4', '224', '230'].includes(localStorage.getItem('eclusrRef')!)) ? // TO REMOVE (WAITING FOR SV DEV)
                <div className={`flex flex-row items-center cursor-pointer`} onClick={() => { renderComponent(MySpaceRenderableComponent.BCTutorials) }}>
                    <FontAwesomeIcon icon={faVideo} className='w-8 h-8 my-2' style={{ color }} />
                    <span className={`ml-2 ${!expanded ? 'hidden' : ''}`}>Mes tutoriels</span>
                    <span className={`w-4 ml-2 ${!expanded ? 'hidden' : ''}`}></span>
                </div> : <></>}

        </div >
    );
};

// Properties definition
SideBarMySpaceMenu.propTypes = {
    changeRenderedComponent: PropTypes.func.isRequired,
    cabinet: PropTypes.object.isRequired,
    dossier: PropTypes.object,

    expanded: PropTypes.bool,
    setExpanded: PropTypes.func,
    className: PropTypes.string,
}